import axios from 'axios'
import {config} from '../config'
export const getTimeline = () =>{
    return axios.get(config.timeline)
    .then(function (response) {
        return response
    })
    .catch(function (error) {
      console.log(error);
    })
}

